// extracted by mini-css-extract-plugin
export default {"card":"styles_card__CI9b5","img_box":"styles_img_box__OdjMy","title":"styles_title__PSPei","description":"styles_description__92-qm"};